import React, { useState } from 'react'
import { Select, TextareaAutosize, CompanyPicker, formatSelectOptions } from '../../../../components'
import { clientService } from '../../services'
import { slugify } from '../../helpers'

const STATUS_OPTIONS = [
  { value: 'active',   label: 'Aktiv' },
  { value: 'inactive', label: 'Inaktiv' },
]

// Shared create/edit form for a client — same dialogRef/hideModalDialog/
// setLoadingModalDialog/onSaved contract as network's PersonEditForm/
// CompanyEditForm. `client` prefills values AND switches the submit to an
// update; omit it for the create flow. The company link is immutable once a
// client exists (B1 decision), so in edit mode the company is a read-only
// display instead of the CompanyPicker.
export const ClientEditForm = ({ client, dialogRef, hideModalDialog, setLoadingModalDialog, onSaved }) => {
  const [companyUuid, setCompanyUuid] = useState(client?.client_company_uuid || '')
  const [companyName, setCompanyName] = useState(client?.company_name || '')
  const [status, setStatus] = useState(client?.client_status || 'active')
  const [notes, setNotes] = useState(client?.client_notes || '')
  const [error, setError] = useState(null)

  const submit = () => {
    setError(null)

    if (client) {
      setLoadingModalDialog(true)
      return clientService.update(client.client_uuid, { status, notes })
        .then(res => {
          setLoadingModalDialog(false)
          hideModalDialog()
          onSaved && onSaved(res.client)
        })
        .catch(err => {
          setLoadingModalDialog(false)
          setError(err.message || 'Kunde inte spara kund')
        })
    }

    if (!companyUuid) {
      setError('Välj eller skapa ett företag')
      return Promise.resolve()
    }

    setLoadingModalDialog(true)
    return clientService.create({ company_uuid: companyUuid, status, notes })
      .then(res => {
        setLoadingModalDialog(false)
        hideModalDialog()
        onSaved && onSaved(res.client)
      })
      .catch(err => {
        setLoadingModalDialog(false)
        setError(err.message || 'Kunde inte skapa kund')
      })
  }

  if (dialogRef) dialogRef.current = { submit }

  const formSlug = client ? client.client_slug : (companyName ? slugify(companyName) : '')

  return (
    <div className="network-form">
      {error && <div className="form-error">{error}</div>}

      <div className="form-block vertical">
        <label>Företag{!client && <span className="cc-required">*</span>}</label>
        {client
          ? <div className="cc-slug-display">{companyName}</div>
          : (
            <CompanyPicker
              name="company_uuid"
              value={companyUuid}
              onChange={({ value: v, company }) => { setCompanyUuid(v); setCompanyName(company?.company_name || '') }}
              allowCreate
            />
          )
        }
      </div>

      <div className="form-block vertical">
        <label>URL-slug</label>
        <div className="cc-slug-display">{formSlug || <span className="cc-slug-placeholder">Genereras automatiskt från företagsnamn</span>}</div>
      </div>

      <div className="form-block vertical">
        <label>Status</label>
        <Select
          name="status"
          value={status}
          options={formatSelectOptions({ options: STATUS_OPTIONS, optionValue: 'value', optionLabel: 'label' })}
          onChange={({ option }) => setStatus(option ? option.value : 'active')}
        />
      </div>

      <div className="form-block vertical">
        <label>Anteckningar<span className="cc-optional">(valfritt)</span></label>
        <TextareaAutosize name="notes" value={notes} onChange={e => setNotes(e.target.value)} minRows={4} />
      </div>
    </div>
  )
}
